import React, { useState } from "react";
// Custom Components
import NoSelection from "../GeneralDisplays/NoSelection";
import UserControl from "../UserControlDisplays/UserControl";
import SponsorControl from "./SponsorControl";
// Styles
import './SettingsControl.css';


const showUsers = 1;
const showSponsors = 2;


// Accepts users, setUsers as prop inputs
// Everything else can be called in component for now
export default function SettingsControl(props) {
    const [displaying, setDisplaying] = useState(null);

    const renderSelection = () => {
        switch (displaying) {
            case showUsers: {
                return (
                    <>
                        <UserControl users={props.users} setUsers={props.setUsers} userData={props.userData} />
                    </>
                )
            }

            case showSponsors: {
                return (
                    <>
                        <SponsorControl />
                    </>
                )
            }
            default:
                return (
                    <NoSelection />
                )
        }
    }

    return (
        <>
            <div className='settings-section'>
                <div className='settings-control'>
                    <h1 className="header">Settings</h1>
                    <div className='settings-items'>
                        <button className='approved-button' onClick={() => {
                            setDisplaying(showUsers);
                        }}>User Settings</button>
                        <button className='approved-button' onClick={() => {
                            setDisplaying(showSponsors);
                        }}>Sponsor Settings</button>
                    </div>
                </div>
                <div className='settings-content-display'>
                    {renderSelection()}
                </div>
            </div>
        </>
    )
}